var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavCablecar = function SvgNavCablecar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M21.3 20c.4 0 .7-.3.7-.7V13l-.4-9.3c0-.9-.8-1.7-1.8-1.7H6.3c-1 0-1.8.7-1.8 1.7L4 13v6.3c0 .4.3.7.7.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 16,
    r: 1.5,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7 5.5H4.3M22 12.5H4"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.6 25-2.3-3M6.6 25l2.2-3"
  })))));
};
export default SvgNavCablecar;